export interface PricingItem {
  key: string;
  displayKey: string;
  value: number;
  rateType?: string;
  _courierId?: string;
  _carrierId?: string;
}

/**
 * Extracts duty charge amount from the pricing array.
 * Backend now delivers dutyCharge as an item with `key: "dutyCharge"` inside `pricing[]`.
 */
export function getDutyCharge(pricing?: PricingItem[] | null): number {
  if (!Array.isArray(pricing)) return 0;
  const duty = pricing.find(p => p?.key === 'dutyCharge');
  return typeof duty?.value === 'number' && !isNaN(duty.value) ? duty.value : 0;
}

/**
 * Helper to compute full pricing sum from pricing and taxPricing arrays if needed.
 */
export function getPricingFullTotal(
  pricing: PricingItem[] = [],
  taxPricing: PricingItem[] = [],
  fallbackTotal?: number,
): number {
  if (typeof fallbackTotal === 'number' && !isNaN(fallbackTotal) && fallbackTotal > 0) {
    return fallbackTotal;
  }
  const pricingSum = (pricing || []).reduce((sum, p) => sum + (Number(p?.value) || 0), 0);
  const taxSum = (taxPricing || []).reduce((sum, t) => sum + (Number(t?.value) || 0), 0);
  return pricingSum + taxSum;
}
